import script from "./customer.vue?vue&type=script&lang=ts&setup=true"
export * from "./customer.vue?vue&type=script&lang=ts&setup=true"

import "./customer.vue?vue&type=style&index=0&id=3116aba1&lang=scss"

const __exports__ = script;

export default __exports__